<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <a href="/teacher/themes/all"><i class="fas fa-book-open mr-1"></i> Temas</a> / <span class="text-muted">Criar Tema</span>
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>

        <div class="container mb-4">
            <div class="row">
                <div class="col-sm-9 mx-auto">
                    <b-overlay :show="loading" rounded="sm">
                        <b-card>
                            <b-form @submit="submit" @submit.stop.prevent>

                                <!-- Field -->
                                <div class="d-md-flex gap-2">
                                    <b-form-group
                                        class="col col-md-8 px-0"
                                        label="Título"
                                        description="Qual é o nome do tema que os alunos irão visualizar ?">
                                        <!-- Input -->
                                        <b-form-input
                                            v-model="form.title"
                                            :state="hasErrors('title', errors)"
                                        ></b-form-input>
    
                                        <!-- Error -->
                                        <has-errors :errors="errors" name="title" />
                                    </b-form-group>
                                    
                                    <b-form-group
                                        class="col col-md-4 px-0"
                                        label="Data de Liberação"
                                        description="Quando ficará disponivel para o aluno?">
                                        <!-- Input -->
                                        <b-form-datepicker
                                            v-model="form.avaliable_in"
                                            label-no-date-selected="Nenhuma data selecionada ..."
                                            locale="pt-BR">
                                        </b-form-datepicker>
    
                                        <!-- Error -->
                                        <has-errors :errors="errors" name="avaliable_in" />
                                    </b-form-group>
                                </div>

                                <!-- Field -->
                                <b-form-group
                                    label="Modo de Correção"
                                    description="Qual o modo de correção das redações deste tema ?">
                                    <!-- Input -->
                                    <multiselect
                                        v-model="mode"
                                        :options="modes"
                                        :loading="loading"
                                        track-by="id"
                                        label="name"
                                        placeholder=""
                                        @select="(value) => this.form.mode_id = value.id"
                                        @remove="() => this.form.mode_id = null"
                                        tag-placeholder="Filtrar Modo de Correção"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                        <span slot="noResult">
                                            Ops! Nenhum resultado encontrado na pesquisa :(
                                        </span>

                                        <span slot="noOptions">
                                            Não há modos de correção disponíveis para exibir :(
                                        </span>

                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="mode_id" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    label="Imagem Pré-Visualização"
                                    description="Será a imagem de destaque que será mostrada junto ao título do tema.">

                                    <!-- Input -->
                                    <div v-if="!preview">
                                        <b-form-file
                                            ref="file"
                                            @change="loadImage($event)"
                                            accept="image/*"
                                            placeholder=""
                                            browse-text="Procurar"
                                            no-drop
                                        ></b-form-file>
                                    </div>

                                    <div v-if="preview" class="mb-2">
                                        <b-button v-if="!form.preview_img_path" variant="secondary" @click="cropImage">
                                            Finalizar Edição
                                        </b-button>

                                        <b-button variant="outline-secondary" @click="changeImage" class="ml-1">
                                            Trocar Imagem
                                        </b-button>
                                    </div>

                                    <!-- Cropper -->
                                    <cropper
                                        class="cropper"
                                        ref="cropper"
                                        v-if="preview && !form.preview_img_path"
                                        :src="preview"
                                        :auto-zoom="true"
                                        :stencil-props="{
                                            aspectRatio: 16/9
                                        }"
                                    />

                                    <!-- Preview -->
                                    <img v-if="form.preview_img_path" :src="form.preview_img_path" class="img-thumbnail" height="350px"/>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="preview_img_path" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group label="Modo de Envio do Conteúdo"
                                    description="De que forma quer enviar o tema da redação ? Digitada ou por PDF ?">

                                    <b-form-radio v-model="form.content_type" name="type" value="PDF">
                                        Quero enviar por PDF o conteúdo do tema
                                    </b-form-radio>

                                    <b-form-radio v-model="form.content_type" name="type" value="TEXT">
                                        Quero digitar o conteúdo do tema
                                    </b-form-radio>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="content_type" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    v-if="form.content_type === 'PDF'"
                                    label="Envio o PDF do Conteúdo"
                                    description="Faça o Upload do Arquivo PDF">

                                    <!-- Input -->
                                    <b-form-file
                                        ref="filePDF"
                                        @change="loadImagePDF($event)"
                                        accept="application/pdf"
                                        placeholder=""
                                        browse-text="Procurar"
                                        no-drop
                                    ></b-form-file>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="content_pdf_path" />

                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    v-if="form.content_type === 'TEXT'"
                                    label="Digite o Conteúdo"
                                    description="Escreva o conteúdo do tema que será mostrado para seus alunos escreverem as redações">

                                    <!-- Input -->
                                    <quill-editor
                                        ref="myQuillEditor"
                                        v-model="form.content"
                                        :options="editorOption"
                                    >
                                    </quill-editor>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="content" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    label="Turmas"
                                    description="Quer que esse tema só pertença a 1 ou mais turmas da sua escola ? Se não quer filtrar por turma é só deixar vazio :)">

                                    <!-- Input -->
                                    <multiselect
                                        v-model="form.groups"
                                        :options="groups"
                                        :loading="loadingGroup"
                                        track-by="id"
                                        label="name"
                                        placeholder=""
                                        :multiple="true"
                                        :taggable="true"
                                        tag-placeholder="Filtrar Turma"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                            <span slot="noResult">
                                                Ops! Nenhum resultado encontrado na pesquisa :(
                                            </span>

                                            <span slot="noOptions">
                                                Não há turmas para exibir no momento :(
                                            </span>

                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="groups" />
                                </b-form-group>

                                <!-- Field -->
                                <b-form-group
                                    label="Tags"
                                    description="Se deseja categorizar melhor o tema, adicione tags para ele. Os alunos poderão filtrar por tags na hora de escolher o tema para escrever a redação.">

                                    <!-- Input -->
                                    <multiselect
                                        v-model="form.tags"
                                        :options="tagsOptions"
                                        :loading="loadingTags"
                                        placeholder=""
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addTag"
                                        tag-placeholder="Adicionar Tag"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                            <span slot="noResult">
                                                Ops! Nenhum resultado encontrado na pesquisa :(
                                            </span>

                                            <span slot="noOptions">
                                                Não há tags marcadas no momento.
                                            </span>

                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="tags" />
                                </b-form-group>

                                <!-- Submit -->
                                <b-button type="submit" variant="primary" :disable="loading">
                                    Criar Tema
                                </b-button>

                                <!-- Cancel -->
                                <a href="/teacher/themes/all" class="ml-2 btn btn-outline-secondary">
                                    Cancelar
                                </a>
                            </b-form>
                        </b-card>
                    </b-overlay>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Cropper
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

// Editor
import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        Cropper,
        quillEditor
    },
    props: ['endpoint', 'modes', 'tags'],
    data() {
        return {
            loading: false,
            loadingGroup: false,
            loadingTags: false,
            errors: {},
            form: {
                mode_id: null,
                title: null,
                preview_img_path: null,
                content_type: 'PDF',
                content: null,
                content_pdf_path: null,
                groups: [],
                tags: [],
                avaliable_in: null,
            },
            mode: null,
            preview: null,
            groups: [],
            tagsOptions: this.tags.map(element => (element.name)),
            editorOption: {
                placeholder: 'Aqui você insere o conteúdo ...',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        ['link', 'image'],
                        ['clean', {'align': [] }]
                    ],
                }
            }
        }
    },
    created() {

        this.searchGroup(null)

    },
    methods: {

        submit() {
            this.loading = true;
            axios.post(this.endpoint, {
                ...this.form,
                groups: this.form.groups.map(element => (element.id))
            })
                .then((result) => {

                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        loadImage(event) {
            let input = event.target;
            if (input.files && input.files[0]) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.preview = e.target.result;
                };
                reader.readAsDataURL(input.files[0]);
            }
        },

        loadImagePDF(event) {
            let input = event.target;
            if (input.files && input.files[0]) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.form.content_pdf_path = e.target.result;
                };
                reader.readAsDataURL(input.files[0]);
            }
        },

        cropImage() {
            const { canvas } = this.$refs.cropper.getResult();
            this.form.preview_img_path = canvas.toDataURL();
        },

        changeImage() {
            this.preview = null;
            this.form.preview_img_path = null
        },

        searchGroup(text) {
            this.loadingGroup = true;
            axios.get('/teacher/groups/search', {
                params: {
                    name: text
                }
            })
                .then((result) => {
                    this.groups = result.data.data.groups;
                })
                .finally(() => this.loadingGroup = false)
        },

        addTag(newTag) {
            this.tagsOptions.push(newTag)
            this.form.tags.push(newTag)
        }
    }
}
</script>

<style scoped>
    .cropper {
        height: 350px;
        background: #DDD;
    }
</style>
